module.exports = __webpack_public_path__ + "static/media/natalie-portman.fc577862.jpg";